import { render, staticRenderFns } from "./PlanSettings.vue?vue&type=template&id=35ec70c4&"
import script from "./PlanSettings.vue?vue&type=script&lang=js&"
export * from "./PlanSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports